<template>
    <div v-bind:class="['dropdown', { error : error, shake : error, animated : error }]">
        <button type="button" class="btn dropdown-toggle" data-toggle="dropdown">
            <span>{{ value ? value.name : variant.variant_name||variant.name }}</span>
            <span class="caret"></span>
        </button>
        <ul class="dropdown-menu" :class="{ small : variantsLength >= 3 || 1 }" role="menu">
            <li v-for="item in sortedVariants">
                <a :class="{ active : isActive(item) }" @click="changeItem(item, item.id)">
                    <i class="fa fa-plus variantMultiple" v-if="variant.is_multiple"></i>
                    {{ item.name }}
                    <strong v-if="item.price">{{ item.price > 0 ? '+' : '' }}{{ item.price }}€</strong>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props : ['variant', 'id', 'errors'],

        data(){
            return {
                value : this.variant.is_multiple ? [] : null,
                error : false,
            };
        },

        mounted(){
            window.eventHub.$on('check-error', this.checkError);
        },

        computed: {
            variantsLength(){
                return Object.values(this.variant.variants||[]).length;
            },
            sortedVariants(){
                var data = [];

                for ( var key in this.variant.variants ){
                    let obj = this.variant.variants[key];
                        obj.id = key;

                    data.push(obj);
                }

                return data.sort((a, b) => {
                    return a._o - b._o;
                });
            },
        },

        methods: {
            changeItem(item, key){
                if ( !(this.name in this.$parent.variants.items) ) {
                    this.$parent.$set(this.$parent.variants.items, this.id, {});
                }

                if ( this.variant.is_multiple == true ) {
                    this.value = _.xorBy(this.value, [item], 'id')

                    let obj = {};
                    this.value.forEach(value => {
                        obj[value.id] = value;
                    });

                    this.$parent.$set(this.$parent.variants.items, this.id, obj);
                } else {
                    if ( this.value == item ) {
                        this.value = null;
                    } else {
                        this.value = this.$parent.$set(this.$parent.variants.items[this.id], key, item);
                    }
                }

                this.error = false;
            },
            isActive(item){
                if ( this.variant.is_multiple ){
                    return _.find(this.value, { id : item.id }) ? true : false;
                }

                return this.value == item;
            },
            checkError(){
                //Variant is not required
                if ( this.variant.is_required == false ){
                    this.error = false;

                    return;
                }

                //Dont allow add product to basket
                //if no variant has been chosen in required variant
                if (
                    (this.variant.is_multiple == false && !this.value)
                    || (this.variant.is_multiple == true && this.value.length == 0)
                ) {
                    this.$parent.canAddToBasket = false;
                }

                setTimeout(function(){
                    //Single variant is empty
                    if ( this.variant.is_multiple !== true ){
                        if ( !this.value ){
                            this.error = true;
                        }
                    }

                    //Multiple variants are empty
                    if ( this.variant.is_multiple == true ){
                        if ( this.value.length == 0 ){
                            this.error = true;
                        }
                    }
                }.bind(this), this.error ? 100 : 0);

                this.error = false;
            },
        }
    }
</script>

<style type="text/css" scoped>
.active > .variantMultiple {
    color: white;
}

.variantMultiple {
    margin-right: 4px;
}
</style>